<template>
  <li class="m-nav__item" :class="{ 'm-nav__item--active': active }">
    <slot />
  </li>
</template>

<script lang="ts">
export default {
  name: 'MNavItem',
  props: {
    /**
     * Whether this is the current nav item
     */
    active: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.m-nav__item {
  align-items: center;
  display: flex;
  height: 100%;
  position: relative;
  white-space: nowrap;

  &--active {
    &::after {
      background-color: var(--color-primary-regular);
      bottom: 0;
      content: '';
      height: 6px;
      left: 0;
      position: absolute;
      width: 100%;
    }
  }
}
</style>
